import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import { useAuth } from '../context/AuthContext';
import UserItem from '../components/UserItem';
import { CircularProgress } from '@mui/material';
import { ChevronLeft } from 'lucide-react';

function EditCloseFriends() {
  const [closeFriends, setCloseFriends] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { userId } = useAuth();

  const fetchCloseFriends = async () => {
    setLoading(true);
    try {
      const myUserId = userId;
      if (!myUserId) {
        navigate('/login');
        return;
      }
      const res = await axiosInstance.get(`/profile/${myUserId}/stalkers`);
      const onlyCloseFriends = res.data.filter(
        (s) => s.rating === 5 && s.close_friends_status === 'approved'
      );
      setCloseFriends(onlyCloseFriends);
    } catch (err) {
      console.error('Error fetching close friends:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCloseFriends();
  }, []);

  const handleRemoveCloseFriend = async (friendId) => {
    try {
      const myUserId = userId;
      if (!myUserId) {
        navigate('/login');
        return;
      }
      await axiosInstance.put(`/profile/${myUserId}/stalkers/${friendId}/downgrade`);
      
      setCloseFriends((prev) => prev.filter((f) => f.user_id !== friendId));
    } catch (err) {
      console.error('Error downgrading close friend:', err);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <CircularProgress size={40} sx={{ color: '#d1d5db' }} />
      </div>
    );
  }

  return (
    <div>
      <div className="top-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <ChevronLeft className="w-8 h-8" />
        </button>
        <h1 className="top-title">Edit Close Friends</h1>
      </div>

      <div className="divide-y divide-gray-200 dark:divide-neutral-800 mx-2 mt-2">
        {closeFriends.length > 0 ? (
          closeFriends.map((friend) => (
            <UserItem
              key={friend.user_id}
              user={friend}
              navigate={navigate}
              hideRating
              onRemove={() => handleRemoveCloseFriend(friend.user_id)}
            />
          ))
        ) : (
          <p className="px-4 py-10 text-center text-sm text-gray-500 dark:text-gray-400">
            No close friends found.
          </p>
        )}
      </div>
    </div>
  );
}

export default EditCloseFriends;
